export const HorizontalPositionClasses = {
  POSITION_LEFT: ['wf-left-0', 'wf-ml-5'],
  POSITION_CENTER: ['wf-inset-x-0', 'wf-mx-auto'],
  POSITION_RIGHT: ['wf-right-0', 'wf-mr-5'],
}

export const VerticalPositionClasses = {
  POSITION_TOP: ['wf-top-0', 'wf-mt-5'],
  POSITION_MIDDLE: ['wf-inset-y-0', 'wf-my-auto'],
  POSITION_BOTTOM: ['wf-bottom-0', 'wf-mb-5'],
}